import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)

const routes = [
	//国泰接口实现单点登录后跳转到合同编辑页面
	// { path: '/contractEdit',
	//     component: () => import('@/views/sign/flow'),
	// hidden: true
	// },
	{
		path: '/login',
		component: () => import('@/views/login'),
		hidden: true
	},
	{
		path: '/loading',
		component: () => import('@/views/loading'),
		hidden: true
	},
	{
		path: '/register',
		component: () => import('@/views/register'),
		hidden: true
	},
	{
		path: '/register-type',
		component: () => import('@/views/register/register-type'),
		hidden: true
	},
	{
		path: '/register',
		component: () => import('@/views/register/register'),
		hidden: true
	},
	// { path: '/register-uk',
	//   component: () => import('@/views/register/register-uk'),
	//   hidden: true
	// },
	{
		path: '/personal-auth-info',
		component: () => import('@/views/auth/personal/auth-info'),
		hidden: true
	},
	{
		path: '/personal-auth-ok',
		component: () => import('@/views/auth/personal/auth-ok'),
		hidden: true
	},
	{
		path: '/company-auth-info',
		component: () => import('@/views/auth/company/auth-info'),
		hidden: true
	},
	{
		path: '/perfect-info',
		component: () => import('@/views/perfect-info/index'),
		hidden: true
	},
	{
		path: '/bind-email',
		component: () => import('@/views/perfect-info/bind-email'),
		hidden: true
	},
	{
		path: '/flow',
		component: () => import('@/views/sign/flow'),
		hidden: true
	},
	{
		path: '/set-control',
		component: () => import('@/views/sign/set-control'),
		hidden: true
	},
	{
		path: '/sign',
		component: () => import('@/views/sign/sign'),
		hidden: true
	},
	{
		path: '/signing',
		component: () => import('@/views/sign/signing'),
		hidden: true
	},
	{
		path: '/temp-create',
		name: 'tempCreate',
		component: () => import('@/views/template/create'),
		hidden: true
	},
	{
		path: '/launchtask',
		name: 'launchtask',
		component: () => import('@/views/template/launch-task'),
		hidden: true
	},
	{
		path: '/temp-info',
		component: () => import('@/views/template/info'),
		hidden: true
	},
	{
		path: '/set-temp-control',
		component: () => import('@/views/template/set-temp-control'),
		hidden: true
	},
	{
		path: '/space',
		component: () => import('@/views/space/nav-control'),
		hidden: true,
		children: [
			{
				path: 'contract-list',
				name: 'ContractList',
				component: () => import('@/views/space/contract-list')
			},
			{
				path: 'signatures-list',
				name: 'SignaturesList',
				component: () => import('@/views/space/user-signatures')
			}
		]
	},
	{
		path: '/approve',
		component: () => import('@/views/space/nav-control'),
		hidden: true,
		children: [
			{
				path: 'list',
				name: 'approveList',
				component: () => import('@/views/space/approveList')
			}
		]
	},
	{
		path: '/user-space',
		component: () => import('@/views/space/user'),
		hidden: true,
		children: [
			{
				path: 'contracts',
				name: 'Contracts',
				component: () => import('@/views/space/user-contracts')
			},
			{
				path: 'signatures',
				name: 'Signatures',
				component: () => import('@/views/space/user-signatures')
			}
		]
	},

	{
		path: '/approve-info',
		name: 'approveInfo',
		component: () => import('@/views/space/approveInfo'),
		hidden: true
	},
	{
		path: '/cart/cart',
		component: () => import('@/views/cart/cart'),
		hidden: true
	},
	{
		path: '/cart/order',
		component: () => import('@/views/cart/order'),
		hidden: true
	},
	{
		path: '/cart/success',
		component: () => import('@/views/cart/feedback'),
		hidden: true
	},
	{
		path: '/company-space',
		component: () => import('@/views/space/company'),
		hidden: true,
		children: [
			// {
			// 	path: 'contracts',  // 合同管理
			// 	name: 'Contracts',
			// 	component: () => import('@/views/space/user-contracts')
			// },
			// {
			// 	path: 'signatures', // 非管理员签章管理
			// 	name: 'Signatures',
			// 	component: () => import('@/views/space/company-signatures')
			// },
			{
				path: 'personal-management',  // 人员管理
				name: 'Personal-Management',
				component: () => import('@/views/space/personal-management')
			},
			{
				path: 'admin-signatures', // 企业管理员-签章管理
				name: 'Admin-Signatures',
				component: () => import('@/views/space/admin-signatures')
			},
			{
				path: 'admin-authorize',  // 企业管理员-授权管理
				name: 'Admin-authorize',
				component: () => import('@/views/space/admin-authorize')
			}
		]
	},
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/user',
		component: () => import('@/views/center/index'),
		hidden: true,
		children: [
			{
				path: 'info',
				name: 'Info',
				component: () => import('@/views/center/info')
			},
			{
				path: 'company-info',
				name: 'CompanyInfo',
				component: () => import('@/views/center/company-info')
			},
			{
				path: 'contact',
				name: 'contact',
				component: () => import('@/views/center/contact')
			},
			{
				path: 'bill',
				name: 'bill',
				component: () => import('@/views/center/bill')
			},
			{
				path: 'config',
				name: 'Config',
				component: () => import('@/views/center/config')
			},
			{
				path: 'settings',
				name: 'settings',
				component: () => import('@/views/center/settings')
			},
			{
				path: 'seal',
				name: 'seal',
				component: () => import('@/views/center/seal')
			},
		]
	},
	{
		path: '/create-sign',
		component: () => import('@/views/center/create-sign'),
		hidden: true
	},
	{
		path: '/oa-sign',
		component: () => import('@/views/sign/oa-sign'),
		hidden: true
	},

	{
		path: '/open-sign',
		component: () => import('@/views/sign/open-sign'),
		hidden: true
	},
	// {
	// 	path: '/unifysign',
	// 	component: () => import('@/views/unifysign/task'),
	// 	hidden: true
	// },
	{
		path: '/unifysign/sign',
		component: () => import('@/views/unifysign/sign'),
		hidden: true
	},

	{
		path: '/unifysign/auto-redirect',
		component: () => import('@/views/unifysign/auto-redirect'),
		hidden: true
	},

	{
		path: '/unifysign/sid2token',
		component: () => import('@/views/unifysign/sid2token'),
		hidden: true
	},

	{
		path: '/unifysign/launch',
		component: () => import('@/views/unifysign/launch'),
		hidden: true
	},

	{
		path: '/unifysign/assign',
		component: () => import('@/views/unifysign/assign'),
		hidden: true
	},
	{
		path: '/unifysign/lauchtask',
		component: () => import('@/views/unifysign/lauchtask'),
		hidden: true
	},
	{
		path: '/autoLogin',
		component: () => import('@/views/unifysign/sid2token'),
		hidden: true
	},
	{
		path: '/file-check',
		component: () => import('@/views/file-check/file-check'),
		hidden: true
	},

	{
		path: '/open/seal/handwrite',
		component: () => import('@/views/center/handwrite'),
		hidden: true
	},

	{
		path: '/open/seal/handwriteSuccess',
		component: () => import('@/views/center/handwriteSuccess'),
		hidden: true
	},

	{
		path: '/open/personAuth/authSuccess',
		component: () => import('@/views/auth/personal/authSuccess'),
		hidden: true
	},

	{
		path: '/open/personAuth/authFailed',
		component: () => import('@/views/auth/personal/authFailed'),
		hidden: true
	},

	{
		path: '/open/personAuth/authSuccessOpen',
		component: () => import('@/views/auth/personal/authSuccessOpen'),
		hidden: true
	},

	{
		path: '/open/personAuth/authFailedOpen',
		component: () => import('@/views/auth/personal/authFailedOpen'),
		hidden: true
	},

	{
		path: '/documentCenter',
		component: () => import('@/views/document-center/document-center'),
		hidden: true
	},
	{
		path: '/electronSeal/serveOrder',
		component: () => import('@/views/electronSeal/serveOrder'),
		hidden: true
	},
	{
		path: '/open/formsign/signLink',
		component: () => import('@/views/formsign/signLink'),
		hidden: true
	},
	{
		path: '/open/formsign/verifyLink',
		component: () => import('@/views/formsign/verifyLink'),
		hidden: true
	},
	//app 页面
	{
		path: '/app/unifysign/sign',
		component: () => import('@/views/app/unifysign/sign'),
		hidden: true
	},
	{
		path: '/electronSeal/serveOrderList',
		component: () => import('@/views/electronSeal/serveOrderList'),
		hidden: true
	},


	// 前端微服务预留
	// {
	//   path: '/child',
	//   name: 'child'
	// }
]

const router = new VueRouter({
	mode: 'history',
	base: '/home/',
	routes
})

export default router
